import styled from 'styled-components';
import { Color } from '@pushwoosh/kit-constants';
export const LinkBox = styled.a.withConfig({
  displayName: "LinkBox",
  componentId: "sc-1d0jwxu-0"
})(["display:inline;padding:0;appearance:none;border:none;background:transparent;color:", ";text-decoration:none;cursor:pointer;&:hover{color:", ";text-decoration:underline;}&:focus-visible{outline:1px solid ", ";outline-offset:2px;}&:active{color:", ";}&:focus:not(:focus-visible){outline:none;}"], Color.PRIMARY, Color.PRIMARY_HOVER, Color.BRIGHT, Color.PRIMARY_PRESSED);
LinkBox.displayName = 'LinkBox';